import request from '../../utils/request'

// 发送公告消息
export function rhMessageCreate (data) {
  return request.post('/pc/rhMessage/create', data)
}
